<script setup lang="ts">
import { toHead } from 'vue-datocms'
import { queryPage } from '~/graphql/page'

const route = useRoute()
const { resolveSectionComponent } = useResolveComponent()
const { throwError } = useNuxtError()

const { data, error } = await useDatoQuery(queryPage, {
  variables: {
    slug: route.params.slug as string
  }
})

if (!data.value?.page || error.value) {
  console.error(error.value)
  throwError(404)
}

if (data.value?.page?.colorTheme && import.meta.env.SSR) {
  useTheme(data.value?.page?.colorTheme as unknown as AppTheme)
}

onMounted(() => {
  if (data.value?.page?.colorTheme && import.meta.client) {
    useTheme(data.value?.page?.colorTheme as unknown as AppTheme)
  }
})

useHead(() => {
  return toHead(data.value?.page?._seoMetaTags || [])
})
</script>

<template>
  <div v-if="data?.page">
    <component
      :is="resolveSectionComponent(item.__typename as SectionComponents)"
      v-for="(item, index) in data.page?.modules"
      :key="item.id"
      :data="item"
      :module-index="index"
      class="relative"
    />
  </div>
</template>
